/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecificationGroup
 */
export interface SpecificationGroup {
    /**
     * 
     * @type {string}
     * @memberof SpecificationGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationGroup
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SpecificationGroup
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the SpecificationGroup interface.
 */
export function instanceOfSpecificationGroup(value: object): boolean {
    return true;
}

export function SpecificationGroupFromJSON(json: any): SpecificationGroup {
    return SpecificationGroupFromJSONTyped(json, false);
}

export function SpecificationGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificationGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function SpecificationGroupToJSON(value?: SpecificationGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'sortOrder': value['sortOrder'],
    };
}

